import { Box, Container, Stack, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import { useEffect, useState } from "react";
import { ApiManager } from "../../utils/apiManager";
import { offerMappingService, OfferData } from "../../utils/offerMapping";
import { BASE_URL } from "../../config";
import MovingBanner from "./MovingBanner";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import collectingMoneyGif from '../../assets/Collecting_Money_20260105064100.gif';
import moneyGif from '../../assets/money_20260105065155.gif';

// import InstallGuideTour from "../common/InstallGuideTour";

export default function Hero({ amount }: { amount?: string | number }) {
  const [url, setUrl] = useState("");
  const [currentGifIndex, setCurrentGifIndex] = useState(0);
  const [isBlueButton, setIsBlueButton] = useState(true);
  const [offerAmount, setOfferAmount] = useState<string>("0");

  const getValidAmount = (value: unknown): string | null => {
    if (typeof value === "number" && Number.isFinite(value) && value >= 0) {
      return value.toString();
    }

    if (typeof value === "string") {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        return null;
      }

      const parsedValue = Number(trimmedValue);
      if (Number.isFinite(parsedValue) && parsedValue >= 0) {
        return trimmedValue;
      }
    }

    return null;
  };



  // GIF sequence: collecting money -> money -> repeat
  const gifSequence = [collectingMoneyGif, moneyGif];

  useEffect(() => {
    const validAmount = getValidAmount(amount);
    setOfferAmount(validAmount ?? "0");
  }, [amount]);

  useEffect(() => {


    const CheckFormValidity = async () => {
      try {
        const currentUrl = window.location.pathname;
        const parts = currentUrl.split("/").filter((part) => part !== "");
        var formNumber = parts.length > 0 ? parts[parts.length - 1] : "0";
        if (formNumber === "fest" || formNumber === "ios") {
          formNumber = "0";
        }

        const apiUrl = `${BASE_URL}/api/form/check-ios-form/?url=${formNumber}`;

        const response = await ApiManager.fetchWithAbort(apiUrl);

        if (response.status === 200) {
          const data = await response.json();
          console.log("API Response:", data);

          // 1. Logic for URL and Active Forms
          if (data.active_forms && Array.isArray(data.active_forms)) {
            const activeForms: OfferData[] = data.active_forms.map((item: { url: string; name: string }) => ({
              url: item.url,
              name: item.name
            }));
            offerMappingService.updateOffers(activeForms);

            // Store the form name for submission
            // Priority 1: Direct name from API response (e.g. "Ring Form")
            // Priority 2: "Kissht" from active forms fallback
            if (data.name) {
              localStorage.setItem('current_form_name', data.name);
            } else if (activeForms.length > 0) {
              const kisshtForm = activeForms.find(f => f.name.toLowerCase().includes('kissht'));
              const formToUse = kisshtForm ? kisshtForm.name : activeForms[0].name;
              localStorage.setItem('current_form_name', formToUse);
            }
          }

          if (data.link) {
            setUrl(data.link);
          }

          // 2. Logic for Offer Amount (Map only real amount values)
          const responseAmount = getValidAmount(data.amount);
          if (responseAmount !== null) {
            setOfferAmount(responseAmount);
            console.log("Found amount in data.amount:", data.amount);
          } else if (data.active_forms && Array.isArray(data.active_forms) && data.active_forms.length > 0) {
            const firstForm = data.active_forms[0];
            const firstFormAmount = getValidAmount(firstForm.amount);
            if (firstFormAmount !== null) {
              setOfferAmount(firstFormAmount);
              console.log("Found amount in active_forms[0].amount:", firstForm.amount);
            } else {
              setOfferAmount("0");
              console.log("No amount found, using default: 0");
            }
          } else {
            setOfferAmount("0");
            console.log("No active forms or amount, using default: 0");
          }

        }
      } catch (err) {
        console.log("Error:", err);
        setOfferAmount("0");
      }
    };

    CheckFormValidity();


  }, []);

  // Cycle through GIFs every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGifIndex((prevIndex) => (prevIndex + 1) % gifSequence.length);
    }, 3000); // Change GIF every 3 seconds

    return () => clearInterval(interval);
  }, [gifSequence.length]);

  // Toggle button color every 3 seconds
  useEffect(() => {
    const colorInterval = setInterval(() => {
      setIsBlueButton(prev => !prev);
    }, 3000);
    return () => clearInterval(colorInterval);
  }, []);


  const navigate = useNavigate();

  const appUrl: string = url;

  return (
    <Box
      id="hero"
      sx={{
        width: "100%",
        background: "linear-gradient(180deg, #FFF3E0 0%, #FFF3E0 55%, #FFFFFF 100%)",
        pt: { xs: 12, sm: 14 },
        pb: 0,
        position: "relative",
        overflow: "hidden",
        minHeight: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
      }}
    >
      {/* <InstallGuideTour target="#hero-install-btn" /> */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flexGrow: 0,
        }}
      >
        <Stack
          spacing={1}
          sx={{
            width: "100%",
            alignItems: "center",
            textAlign: "center",
            mb: 1
          }}
        >
          {/* First Line: Earn + Amount + by */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'baseline', justifyContent: 'center' }}>
            <Typography
              sx={{
                fontSize: "clamp(2rem, 6vw, 3.5rem)",
                color: "#3F51B5", // Blue for "Earn"
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
                fontFamily: "General-Sans-bold, sans-serif",
              }}
            >
              Earn
            </Typography>
            <Typography
              sx={{
                fontSize: "clamp(3rem, 8vw, 5rem)", // Bigger font size for amount
                color: "#FFB300", // Gold for amount
                fontWeight: 800,
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
                fontFamily: "General-Sans-bold, sans-serif",
              }}
            >
              ${offerAmount}
            </Typography>
            <Typography
              sx={{
                fontSize: "clamp(2rem, 6vw, 3.5rem)",
                color: "#3F51B5", // Blue for "by"
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
                fontFamily: "General-Sans-bold, sans-serif",
              }}
            >
              By
            </Typography>
          </Box>

          {/* Second Line: Installing This Offer */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'baseline', justifyContent: 'center' }}>
            <Typography
              sx={{
                fontSize: "clamp(2rem, 6vw, 3.5rem)",
                color: "#3F51B5", // Blue shade
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
                fontFamily: "General-Sans-bold, sans-serif",
              }}
            >
              Installing This Offer
            </Typography>
          </Box>
        </Stack>

        {/* Money Collecting Animation - Cycling */}
        <Box
          id="animation-container"
          sx={{
            width: "280px",
            height: "280px",
            mt: 0.5,
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative"
          }}
        >
          <img
            key={currentGifIndex} // Force re-render on GIF change
            src={gifSequence[currentGifIndex]}
            alt="Money Animation"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              transition: 'opacity 0.3s ease-in-out'
            }}
            data-track="gif"
            data-name={`hero_money_animation_${currentGifIndex}`} // Dynamic name to track which part of sequence
          />
        </Box>

        <Button
          id="hero-install-btn"
          variant="contained"
          onClick={() => {
            // ✅ Set flag before redirect
            localStorage.setItem('install_initiated', 'true');
            localStorage.setItem('current_offer_amount', offerAmount);



            // 1. Navigate to submitting page first (so when user comes back, they are there)
            navigate('/submit-task');
            // 2. Open the app store link
            window.location.href = appUrl;
          }}
          sx={{
            background: isBlueButton ? "#2962FF" : "linear-gradient(90deg, #FFECB3 0%, #FFC107 100%)", // Blue or Yellow
            color: isBlueButton ? "#fff" : "#000",
            borderRadius: "25px",
            textTransform: "none",
            fontSize: "1.1rem",
            fontWeight: 700,
            width: "85%",
            maxWidth: "350px",
            py: 1.5,
            transition: "all 0.5s ease-in-out",
            boxShadow: isBlueButton ? "0 4px 15px rgba(41, 98, 255, 0.4)" : "0 4px 15px rgba(255, 193, 7, 0.4)",
            fontFamily: "General-Sans-bold, sans-serif",
            "&:hover": {
              background: isBlueButton ? "#1A237E" : "linear-gradient(90deg, #FFE082 0%, #FFB300 100%)",
              boxShadow: isBlueButton ? "0 6px 20px rgba(41, 98, 255, 0.5)" : "0 6px 20px rgba(255, 193, 7, 0.5)",
            }
          }}
          endIcon={<FileDownloadOutlinedIcon sx={{ ml: 1 }} />}
        >
          Install this offer
        </Button>




      </Container>

      <Box sx={{ width: '100%', mt: 4 }}>
        <MovingBanner />
      </Box>
    </Box>
  );
}
